/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react';
import { RED_CREEK, SUNSET_GOLD } from '../styles/colors';


/**
 * Apply to the form root for all of its immediate children to space themselves out vertically by 25px
 */
export const COLUMN_SPACING = css`
  & > span {
    display: block;
  }
  
  & > * {
    margin-bottom: 25px;
  }
  
  & > *:last-child {
    margin-bottom: 0;
  }
  min-height: 300px;
`;


export const ROW_SPACING = css`
  & > * {
    margin-right: 25px;
  }
  
  & > *:last-child {
    margin-right: 0;
  }
`;

export const ROW_SPACING_WIDE = css`
  & > * {
    margin-right: 40px;
  }

  & > *:last-child {
    margin-right: 0;
  }
`;

export const ROW_SPACING_NARROW = css`
  & > * {
    margin-right: 15px;
  }

  & > *:last-child {
    margin-right: 0;
  }
`;

/**
 * Shows a red border around the component this style is applied to
 */
export const ERROR_BORDER = css`
  border: 3px solid ${RED_CREEK};
`;

/**
 * Shows a yellow border around the component this style is applied to
 */
export const WARNING_BORDER = css`
  border: 3px solid ${SUNSET_GOLD};
`;